const base = require('../base.js');
const data = require('../data.js');
const state = require('../state.js');
const FileSaver = require('file-saver');
const JSPDF = require('jspdf');
const patientListTemplate = require('../templates/patient-list.jade');
const patientNumeratorListWrapperTemplate = require('../templates/patient-numerator-list-wrapper.jade');
require('jspdf-autotable');

let patientsPanel;
let currentPatients;

const writeToFile = (list) => {
  const blob = new Blob([list.join('\r\n')], { type: 'text/plain;charset=utf-8' });
  FileSaver.saveAs(blob, 'nhsNumbers.txt');
};

const parseHtml = html => html
  .replace(/<[^>]*>/g, '')
  .replace('&gt;', '>')
  .replace('&gte;', '≥')
  .replace('&lt;', '<')
  .replace('&lte;', '≤');

const writePdf = () => {
  const columns = currentPatients['header-items'].map(v => v.title);
  const rows = currentPatients.patients.map(v => [v.nhs, v.age, v.value]);

  const extraInfo = data.getIndicatorDataSync(null, currentPatients.indicatorId);

  const doc = new JSPDF('l');
  doc.setFontSize(18);
  let y = 22;
  const mainHeader = doc.splitTextToSize(
    parseHtml(extraInfo.name),
    doc.internal.pageSize.getWidth() - 35,
    {}
  );
  doc.text(mainHeader, 14, y);
  doc.setFontSize(11);
  doc.setTextColor(100);
  y += mainHeader.length * 8;
  const tagline = doc.splitTextToSize(
    `${extraInfo.performance.percentage}% (${extraInfo.performance.fraction}) ${parseHtml(extraInfo.tagline)}`,
    doc.internal.pageSize.getWidth() - 35,
    {}
  );
  doc.text(tagline, 14, y);
  y += tagline.length * 7;
  doc.setFontSize(14);
  doc.setTextColor(0);
  const subHeader = doc.splitTextToSize(
    `${parseHtml(currentPatients.header)} (n=${currentPatients.patients.length})`,
    doc.internal.pageSize.getWidth() - 35,
    {}
  );
  doc.text(subHeader, 14, y);
  doc.setFontSize(11);
  doc.setTextColor(100);
  y += subHeader.length * 8;
  doc.autoTable(columns, rows, {
    startY: y,
    showHeader: 'firstPage',
    styles: {
      overflow: 'linebreak',
      columWidth: 'wrap',
    },
  });

  doc.save('patient-list.pdf');
};

const pl = {
  wireUp(onPatientSelected) {
    let buttonClicked = false;

    patientsPanel = $('#patients-numerator');

    patientsPanel
      .on('click', 'tbody tr', (e) => {
        // Select individual patient when row clicked#
        if (!buttonClicked) {
          const callback = onPatientSelected.bind(e.currentTarget);
          const patientId = $(e.currentTarget)
            .find('td button')
            .attr('data-patient-id');
          const type = $(e.currentTarget)
            .find('td button')
            .attr('data-type');
          callback(patientId, type);
          e.preventDefault();
          e.stopPropagation();
        }
        buttonClicked = false;
      })
      .on('click', 'tbody tr button', () => {
        // don't want row selected if just button pressed?
        // but can't use:
        // e.preventDefault();
        // e.stopPropagation();
        // as it seems the clipboard event is triggered last
        buttonClicked = true;
      })
      .on('click', '#downloadAsPdf', (e) => {
        writePdf();
        e.preventDefault();
      })
      .on('click', '#downloadAsText', (e) => {
        writeToFile(currentPatients.patients.map(v => v.nhs));
        e.preventDefault();
      });
  },

  restoreFromState() {
    pl.populate.apply(this, pl.state);
  },

  populate(
    pathwayId,
    pathwayStage,
    standard,
    sortField,
    sortAsc
  ) {
    pl.state = [
      pathwayId,
      pathwayStage,
      standard,
      sortField,
      sortAsc,
    ];
    patientsPanel = $('#patients-numerator');
    base.showLocalLoading(patientsPanel, 'Loading patient list...');

    data.getPatientNumeratorList(
      state.selectedPractice._id,
      pathwayId,
      pathwayStage,
      standard,
      (listOfPatients) => {
        const list = listOfPatients;
        list.elementId = 'patient-numerator-list';
        list.indicatorId = [pathwayId, pathwayStage, standard].join('.');
        list.selectedPractice = state.selectedPractice;
        currentPatients = list;
        base.createPanelShow(
          patientListTemplate,
          patientsPanel,
          list
        );

        $('#patients-placeholder').hide();

        const numColumns = list['header-items'].length;
        state.patientNumeratorListTable = $('#patient-numerator-list').DataTable({
          searching: false, // we don't want a search box
          stateSave: true, // let's remember which page/sorting etc
          dom:
            '<"p-list-header fx"<"col-sm-9 col-xl-8 toolbar"i><"col-sm-3 col-xl-4 fx fx-v-mid fx-h-r"B>>rt<"p-list-footer fx"<"col-sm-4 fx fx-v-mid fx-h-l"l><"col-sm-8 fx fx-v-mid fx-h-r"p>><"clear">',
          columnDefs: list['header-items'].map((v, i) => {
            const thing = {
              type: v.type,
              orderSequence: v.orderSequence,
              targets: i,
              name: 'shown',
            };
            if (v.hidden) {
              thing.visible = false;
              thing.name = 'not';
            } else if (i < numColumns - 2) {
              // everything sorted by exclusion first except exclusion column
              // thing.orderData = [[numColumns - 1, 'asc'], i];
            }
            return thing;
          }),
          scrollY: '50vh',
          scrollCollapse: true,
          buttons: [
            {
              extend: 'colvis',
              text: 'Col picker',
              columns: 'shown:name',
              className: 'btn-xs hide-1280',
            },
            {
              extend: 'colvis',
              columns: 'shown:name',
              className: 'btn-xs show-inline-1280 hide-1600',
            },
            {
              extend: 'colvis',
              columns: 'shown:name',
              className: 'show-inline-1600',
            },
            {
              text: 'Pdf',
              className: 'download-button',
              action: () => {
                // props e, dt, node, config
                // writePdf();
              },
            },
          ],
          infoCallback: (settings, start, end, max, total) => `showing ${start} to ${end} of ${total} patients`,
        });

        $('#patient-numerator-list').on('draw.dt', () => {
          base.setupClipboard('.btn-copy', true);
          base.wireUpTooltips();
        });

        // ensure charts are resized
        const visibleChart = $('div[data-highcharts-chart]:visible');
        if (visibleChart.length > 0) visibleChart.highcharts().reflow();

        setTimeout(() => {
          state.patientNumeratorListTable.columns.adjust().draw(false);

          base.setupClipboard('.btn-copy', true);
          base.wireUpTooltips();
        }, 100);

        const updateInfo = () => {
          $('#patient-numerator-list_info')
            .html(`
              <span class="h4">${list.header}</span>
              <span> (${$('#patient-numerator-list_info').text().toLowerCase()})</span>
            `)
            .css('white-space', 'normal');
        };

        $('.download-button').replaceWith($(`
          <div class="btn-group">
            <button id="downloadPatientList" class="btn btn-xs btn-danger hide-1600 dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Download</button>
            <button id="downloadPatientList" class="btn btn-danger show-inline-1600 dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Download patient list</button>
            <ul class="dropdown-menu pull-right">
              <li><a id="downloadAsPdf" href="#">Full list (pdf)</a></li>
              <li><a id="downloadAsText" href="#">Nhs numbers (text file)</a></li>
            </ul>
          </div>`));

        updateInfo();

        // Must update after every redraw
        $('#patient-numerator-list').on('draw.dt', () => {
          updateInfo();
        });

        $('.dt-buttons').addClass('pull-right');

        base.hideLoading();
      }
    );
  },

  show(
    panel,
    isAppend,
    pathwayId,
    pathwayStage,
    standard,
    loadContentFn
  ) {
    // var tempMust = $('#patients-panel-yes').html();
    const tmpl = patientNumeratorListWrapperTemplate;

    if (isAppend) panel.append(tmpl());
    else panel.html(tmpl());

    pl.wireUp((patientId, type) => {
      let url = `#patient/${patientId}`;
      if (pathwayId && pathwayStage && standard) { url += `/${[pathwayId, pathwayStage, standard].join('/')}`; }
      window.history.pushState(null, null, url);
      loadContentFn(url);
    });
    pl.populate(pathwayId, pathwayStage, standard);
  },
};

module.exports = pl;
